'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _imageHelper = require('../../element/image/imageHelper');

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _mediaConstants = require('../../../common/media/mediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component renders the appropriately sized image based on the size of the image and the image sizes available
 * to select from.
 */
// Lib
var ResponsiveImageFACC = function ResponsiveImageFACC(_ref) {
    var imageType = _ref.imageType,
        imageDetails = _ref.imageDetails,
        size = _ref.size,
        children = _ref.children;

    if (!imageDetails) return null;

    var imageName = (0, _imageHelper.getResponsiveImageName)(size, _mediaConstants.IMAGE_TYPE_CONFIGS[imageType].sizes);
    var imageSource = imageDetails.get(imageName);

    if (!imageSource) {
        _logger2.default.warn('Expected a source \'' + imageSource + '\' but unable to find it', imageSource);
        return null;
    }

    return children(imageSource);
};

// Constants


// Util


ResponsiveImageFACC.propTypes = {
    imageType: _propTypes2.default.string.isRequired,
    imageDetails: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.number.isRequired
};

exports.default = ResponsiveImageFACC;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/ResponsiveImageFACC.js
// module id = 704
// module chunks = 0